import { z } from "zod"
import { ElectricityMeterKind } from "../types/electricityMeterPointKind"

export const ElectricityMeterPointKindSchema = z.enum(ElectricityMeterKind)
